import moment from 'moment';
import AudioPlayerItem from '../../../../../components/common/AudioPlayerItem';

export type ChatType = {
  _id: string;
  commentBy?: Record<string, any>;
  updatedAt: string;
  comment: string;
  type?: string;
  contentType?: string;
};

type Props = {
  chat: ChatType;
  boxBg: string;
  circleBg: string;
  onBoxClick?: () => void;
};

function ChatBox({chat, boxBg, circleBg, onBoxClick}: Props) {
  const isAudio = chat?.type === 'audio' || chat?.contentType === 'audio';

  return (
    <div
      className={`flex items-center gap-2 px-3 py-[6px] rounded-lg`}
      style={{backgroundColor: boxBg}}
      onClick={() => {
        if (!isAudio && onBoxClick) onBoxClick();
      }}>
      <div className="flex items-start gap-2">
        <div
          className={`w-[48px] h-[48px] rounded-full flex justify-center items-center`}
          style={{backgroundColor: circleBg}}>
          <span className="text-[16px] font-normal text-black">
            {chat?.commentBy?.firstName
              ?.split('')[0]
              ?.charAt(0)
              ?.toUpperCase() || 'U'}
            {chat?.commentBy?.lastName
              ?.split('')[0]
              ?.charAt(0)
              ?.toUpperCase() || 'N'}
          </span>
        </div>

        <div className="flex flex-col">
          <div className="flex items-center gap-1">
            <span className="text-black">
              {moment(chat.updatedAt).format('DD-MM-YYYY HH:mm')}
            </span>

            <span className="text-black">|</span>
            <span className="text-black">
              {chat?.commentBy?.firstName || 'Unknown'}{' '}
              {chat?.commentBy?.lastName || 'User'}
            </span>
          </div>

          {isAudio ? (
            <AudioPlayerItem audioUrl={chat.comment} />
          ) : (
            <span className="text-black text-break">{chat.comment}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatBox;
